
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-viewings",
      function () {
        return require("private-next-pages/open-viewings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-viewings"])
      });
    }
  